import invariant from 'invariant'

import { getCurrentOrgKey } from '../callApi'

export default function prependOrg(path: string) {
  const organizationKey = getCurrentOrgKey()

  invariant(
    organizationKey,
    'Could not prepend an organization to the url because the user seems to be logged out.'
  )

  return `/${organizationKey}${path}`
}
